import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import ClaimAttachment from '../../entities/customercare/claimattachment'
import Claim from '../../entities/customercare/claim'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface ClaimAttachmentState extends ListState<ClaimAttachment>{
    editModel: ClaimAttachment;
    claim: number;
    itemLoading: boolean;
}
class ClaimAttachmentModule extends ListModule<ClaimAttachmentState,any,ClaimAttachment>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<ClaimAttachment>(),
        loading: false,
        itemLoading: false,
        editModel: new ClaimAttachment(),
        activeList: new Array<ClaimAttachment>(),
        claim: 0,
        path: 'claim-attachments'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async upload(context: ActionContext<ClaimAttachmentState, any>, payload: any) {
            context.state.itemLoading = true;
            let response = await Ajax.post('/api/claim-attachments-upload', payload.data).catch(e => {
                context.state.itemLoading = false;
                return Promise.reject(e);
            });
            context.state.itemLoading = false;
            context.state.list = response.data.result;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        init(state: ClaimAttachmentState, model: Claim) {
            state.editModel = Object.assign({});
            state.claim = 0;
            if (model != undefined) {
                state.claim = model.id;
            }
        },
        new(state: ClaimAttachmentState) {
            state.editModel = Object.assign({});
            state.editModel.filename = null;
        },
    });
}
const claimattachmentModule=new ClaimAttachmentModule();
export default claimattachmentModule;
